/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleLandingPageFunnelSummaryData
 */
export interface GoogleLandingPageFunnelSummaryData {
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    normalizedUrls?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    matchedUrls?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    searchConsoleOnlyUrls?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    ga4OnlyUrls?: number;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    searchConsoleClicks?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    searchConsoleImpressions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    searchConsoleCtr?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    ga4Sessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    ga4EngagedSessions?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    ga4KeyEvents?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    ga4Purchases?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    ga4Revenue?: string;
    /**
     * Diagnostic aggregate ratio of GA4 sessions to Search Console clicks.
     * @type {string}
     * @memberof GoogleLandingPageFunnelSummaryData
     */
    sessionsPerSearchConsoleClick?: string | null;
}

/**
 * Check if a given object implements the GoogleLandingPageFunnelSummaryData interface.
 */
export function instanceOfGoogleLandingPageFunnelSummaryData(value: object): value is GoogleLandingPageFunnelSummaryData {
    return true;
}

export function GoogleLandingPageFunnelSummaryDataFromJSON(json: any): GoogleLandingPageFunnelSummaryData {
    return GoogleLandingPageFunnelSummaryDataFromJSONTyped(json, false);
}

export function GoogleLandingPageFunnelSummaryDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleLandingPageFunnelSummaryData {
    if (json == null) {
        return json;
    }
    return {
        
        'normalizedUrls': json['normalizedUrls'] == null ? undefined : json['normalizedUrls'],
        'matchedUrls': json['matchedUrls'] == null ? undefined : json['matchedUrls'],
        'searchConsoleOnlyUrls': json['searchConsoleOnlyUrls'] == null ? undefined : json['searchConsoleOnlyUrls'],
        'ga4OnlyUrls': json['ga4OnlyUrls'] == null ? undefined : json['ga4OnlyUrls'],
        'searchConsoleClicks': json['searchConsoleClicks'] == null ? undefined : json['searchConsoleClicks'],
        'searchConsoleImpressions': json['searchConsoleImpressions'] == null ? undefined : json['searchConsoleImpressions'],
        'searchConsoleCtr': json['searchConsoleCtr'] === undefined ? undefined : json['searchConsoleCtr'] === null ? null : json['searchConsoleCtr'],
        'ga4Sessions': json['ga4Sessions'] == null ? undefined : json['ga4Sessions'],
        'ga4EngagedSessions': json['ga4EngagedSessions'] == null ? undefined : json['ga4EngagedSessions'],
        'ga4KeyEvents': json['ga4KeyEvents'] == null ? undefined : json['ga4KeyEvents'],
        'ga4Purchases': json['ga4Purchases'] == null ? undefined : json['ga4Purchases'],
        'ga4Revenue': json['ga4Revenue'] == null ? undefined : json['ga4Revenue'],
        'sessionsPerSearchConsoleClick': json['sessionsPerSearchConsoleClick'] === undefined ? undefined : json['sessionsPerSearchConsoleClick'] === null ? null : json['sessionsPerSearchConsoleClick'],
    };
}

export function GoogleLandingPageFunnelSummaryDataToJSON(json: any): GoogleLandingPageFunnelSummaryData {
    return GoogleLandingPageFunnelSummaryDataToJSONTyped(json, false);
}

export function GoogleLandingPageFunnelSummaryDataToJSONTyped(value?: GoogleLandingPageFunnelSummaryData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'normalizedUrls': value['normalizedUrls'],
        'matchedUrls': value['matchedUrls'],
        'searchConsoleOnlyUrls': value['searchConsoleOnlyUrls'],
        'ga4OnlyUrls': value['ga4OnlyUrls'],
        'searchConsoleClicks': value['searchConsoleClicks'],
        'searchConsoleImpressions': value['searchConsoleImpressions'],
        'searchConsoleCtr': value['searchConsoleCtr'],
        'ga4Sessions': value['ga4Sessions'],
        'ga4EngagedSessions': value['ga4EngagedSessions'],
        'ga4KeyEvents': value['ga4KeyEvents'],
        'ga4Purchases': value['ga4Purchases'],
        'ga4Revenue': value['ga4Revenue'],
        'sessionsPerSearchConsoleClick': value['sessionsPerSearchConsoleClick'],
    };
}

